import { createRequestTypes } from '../utils';

export const ACTION_LIST = createRequestTypes('action/ACTION_LIST');
